import { CommonSuccessResponse } from "constants/types/common";
import { PermissionType } from "constants/types/permission";
import useSWR from "swr";

export const usePermissions = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<PermissionType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(`/permission`, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    dedupingInterval: 3600000,
    keepPreviousData: true,
  });

  const permission = data?.data;

  return {
    permission,
    error,
    isLoading,
    mutate,
  };
};
